//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      treeId: null,
      trees: [],
      messages: [],
      content: '',
      msgType: 'text',
      msgTypes: [
        { k: 'text', n: '普通' },
        { k: 'cheer', n: '加油' },
        { k: 'reminder', n: '提醒' }
      ]
    }
  },
  created () {
    const id = this.$route.query.id
    if (id) {
      this.treeId = id
      this.loadMessages()
    } else {
      this.$ajax.get(this.$api.etTreeMyList).then(r => {
        this.trees = (r && r.list) || []
        if (this.trees.length === 1) {
          this.selectTree(this.trees[0].tree.id)
        }
      })
    }
  },
  methods: {
    selectTree (id) {
      this.treeId = id
      this.$router.replace({ path: '/etMessages_display', query: { id, hideTrans: 'true' } })
      this.loadMessages()
    },
    loadMessages () {
      this.$ajax.get(this.$api.etTreeMessages + '?id=' + this.treeId).then(r => {
        this.messages = r || []
      }).catch(e => { this.$toast && this.$toast(e.message || '加载失败') })
    },
    typeLabel (t) {
      if (t === 'cheer') return '加油'
      if (t === 'reminder') return '提醒'
      return t
    },
    send () {
      if (!this.content.trim()) {
        this.$toast && this.$toast('请输入内容')
        return
      }
      this.$ajax.post(this.$api.etTreeMessageSend, {
        tree_id: this.treeId,
        content: this.content,
        msg_type: this.msgType
      }).then(() => {
        this.content = ''
        this.loadMessages()
      }).catch(e => { this.$toast && this.$toast(e.message || '发送失败') })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/etymology-tree/messages.vue